import React from 'react'

type AllowedElement<T extends object> =
  | React.ReactElement<T>
  | null
  | undefined
  | boolean
  | ''

/**
 * Render children with props
 */
export const renderChildrenWithProps = <P extends object>(
  children: AllowedElement<P> | AllowedElement<P>[],
  props: P,
): React.ReactElement<P>[] => {
  const childrenArray = React.Children.toArray(
    children,
  ) as React.ReactElement<P>[]

  return childrenArray.map((child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, props)
    }

    throw new Error('Invalid element detected in renderChildrenWithProps')
  })
}
